import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import {
  TEACHER_CATHEDRAS_STARTED,
  TEACHER_CATHEDRAS_COMPLETED,
  CURRICULUM_COURSES_STARTED,
  CURRICULUM_COURSES_COMPLETED,
} from './types';

export const getTeacherCathedras = () =>
  async (dispatch, getState) => {
    const { mid } = getState().auth;
    const url = `${BACKEND_URL_PREFIX}/cathedra/teacher/f/${mid}`;

    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    dispatch({ type: TEACHER_CATHEDRAS_STARTED, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: TEACHER_CATHEDRAS_COMPLETED, data: result });
    } else {
      throw new Error('Can not get cathedras');
    }
  }

export const getCurriculumCourses = () =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/course`;

    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    dispatch({ type: CURRICULUM_COURSES_STARTED, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: CURRICULUM_COURSES_COMPLETED, data: result });
    } else {
      throw new Error('Can not get courses');
    }
  }
